module.exports = __webpack_public_path__ + "static/media/menu-close.c2b640f8.svg";